import React from 'react';
import { ArrowRight } from '../../../static/svg/ArrowRight';

interface IBreadCrumb {
  productSelected: string;
  productType?: string;
}

const BreadCrumb = (props: IBreadCrumb) => {
  const { productSelected, productType } = props;
  return (
    <>
      <div className="w-full flex lg:container lg:mx-auto xs:px-4 lg:px-0 my-5">
        <div className="w-full flex flex-row items-center justify-start text-sm">
          <a href="/" className="relative uppercase overflow-hidden after:bg-golden default-a">
            Home
          </a>
          <span className="px-3">
            <ArrowRight className="w-2.5 h-2.5" strokeWidth="1.5" />
          </span>
          <p className="uppercase">
            R&G {productType === 'kit' || productSelected === 'facewash' ? `` : `Face`}{' '}
            {productSelected}
          </p>
        </div>
      </div>
    </>
  );
};

export default BreadCrumb;
